import { InventoryMeterMountType, isInventoryMeterMountType } from '@enmon/commons/lib/tools/api/inventory-meter';

export type MeterMountTypeSelection = '' | InventoryMeterMountType;

export function isRemoteReadingMountType(mountType: MeterMountTypeSelection) {
  return mountType === InventoryMeterMountType.MountedFree || mountType === InventoryMeterMountType.MountedOccupied;
}

export function readMountType(value: unknown): MeterMountTypeSelection {
  if (isInventoryMeterMountType(value)) {
    return value;
  }

  return '';
}

export function readInventoryMeterMountType(value: unknown): InventoryMeterMountType {
  return isInventoryMeterMountType(value) ? value : InventoryMeterMountType.Free;
}
